export function sortByText<T>(
  items: readonly T[],
  ...keySelectors: ((item: T) => string | null | undefined)[]
): T[] {
  const sortedItems = [...items];

  sortedItems.sort((firstItem, secondItem) => {
    for (const keySelector of keySelectors) {
      const keyComparison = compareNaturalText(keySelector(firstItem) ?? null, keySelector(secondItem) ?? null);

      if (keyComparison !== 0) {
        return keyComparison;
      }
    }

    return 0;
  });

  return sortedItems;
}

/** Case-insensitive, number-aware text comparison: "Kennel 2" sorts before "Kennel 10". Missing text compares as empty. */
export function compareNaturalText(first: string | null, second: string | null): number {
  const comparison = (first ?? '').localeCompare(second ?? '', undefined, { numeric: true, sensitivity: 'base' });

  return comparison;
}
